var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconRemove = function SvgIconRemove(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.792 10.542a.53.53 0 0 1-.383-.155.51.51 0 0 1-.159-.383q0-.228.156-.387a.52.52 0 0 1 .386-.159h8.416a.53.53 0 0 1 .383.155q.159.154.159.383a.53.53 0 0 1-.156.387.52.52 0 0 1-.386.159z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconRemove);
export { ForwardRef as ReactComponent };